import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-gallery-viewer',
  templateUrl: './gallery-viewer.component.html',
  styleUrls: ['./gallery-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class GalleryViewerComponent implements OnInit {
  @Input() imageUrls: string[] = [];
  @Output() closed = new EventEmitter<void>();

  currentIndex: number = 0;
  isOpen: boolean = false;

  ngOnInit() {
    if (this.imageUrls.length > 0) {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.isOpen = false;
    document.body.style.overflow = 'auto';
    this.closed.emit();
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.imageUrls.length;
  }

  previous() {
    this.currentIndex =
      (this.currentIndex - 1 + this.imageUrls.length) % this.imageUrls.length;
  }

  setCurrentImage(index: number) {
    this.currentIndex = index;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}
